
export const MessageModel = {
  id: null,
  text: "", 
  startDate: "", 
  expirationDate: "", 
  amberAlert: false, 
  priority: null, 
  metroAreaId: '', 
  latitude: "", 
  longitude: "" 
  
};

export const getAllMessages = async(activeOnly,includeIncidentMessages,setMessages)=>{
  var endpoint = '/admin/messages/all.json?activeOnly='+ activeOnly +"&includeIncidentMessages="+includeIncidentMessages;
      
      try {
        const res = await fetch( process.env.REACT_APP_API_HOST + endpoint, {
          method: "GET",
        });
        res.json().then((res)=> {
          setMessages(res.data);
          });
          
        if (!res.ok) {
          throw new Error(`Error ${res.status}: ${res.statusText}`);
        }
      } catch (err) {
      }
}


export const getMessageLogs = async (
  messageId,
  setMessageLogs
) => {
  var endpoint = "/admin/messagelogs/logs.json?id=" + messageId;
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
        headers: {
                'Content-Type': 'application/json'
              },
              body:JSON.stringify({id:messageId}),
    });
    res.json().then((res) => {
      setMessageLogs(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getMessage = async (messageId, setMessage) => {
  var endpoint =
    "/admin/messages/" + messageId + "/motd.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setMessage(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getPriorities = async(setPriorities) => {
  var endpoint = "/admin/messages/priorities.json";
  try{
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res)=>{
      setPriorities(res.data);
    });
    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err){}
}; 



export const createMessage = async (message) => {
  var endpoint = "/admin/messages/motd.json";
  message.creationDate=new Date().toISOString();
  message.lastUpdate=new Date().toISOString();
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(message),
    })
      .then((res) => {
        alert("New Message is Created");
      })
      .then((data) => {
      });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const saveMessage = async (message) => {
  var endpoint =
    "/admin/messages/" + message.id + "/motd.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(message),
    })
      .then((res) => {
        alert("Message has been Updated Successfully.");
      })
      .then((data) => {
      });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const deleteMessage = async (message) => {
  var endpoint =
    "/admin/messages/" + message.id + "/motd.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "DELETE",
    }).then((res) => {
      alert("Message has been Deleted Successfully.");
    });
    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};


